// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__Kr3vM","col":"styles_col__2CkRa","fulfillmentStatus":"styles_fulfillmentStatus__3EMIh","emailCol":"styles_emailCol__2dVOd"};